import { z } from "zod";
import { dmaCalculationFailureDtoSchema } from "../dma-calculation";
import { dmaCalculationRunStageSchema } from "./dma-calculation-run-stage.schema";
export const dmaCalculationRunSchema = z.object({
    startedAt: z.string().datetime(),
    finishedAt: z.string().datetime(),
    outcome: z.enum(["succeeded", "failed", "canceled"]),
    failures: z.optional(z.array(dmaCalculationFailureDtoSchema)),
    calculationStages: z.optional(z.array(dmaCalculationRunStageSchema)),
});
